module.exports = __webpack_public_path__ + "img/home_picture.a73e2dca.jpg";